"use client";

import { useEffect, useState } from "react";
import Script from "next/script";

const MOBILE_MEDIA_QUERY = "(max-width: 768px)";

export default function ThirdPartyScripts() {
  const [deviceReady, setDeviceReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const update = () => setIsMobile(mediaQuery.matches);

    update();
    setDeviceReady(true);

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", update);
      return () => mediaQuery.removeEventListener("change", update);
    }

    mediaQuery.addListener(update);
    return () => mediaQuery.removeListener(update);
  }, []);

  useEffect(() => {
    if (!deviceReady || hasInteracted) {
      return;
    }

    const markInteracted = () => setHasInteracted(true);
    const passiveOptions: AddEventListenerOptions = {
      passive: true,
      once: true,
    };
    const onceOptions: AddEventListenerOptions = { once: true };

    window.addEventListener("scroll", markInteracted, passiveOptions);
    window.addEventListener("touchstart", markInteracted, passiveOptions);
    window.addEventListener("pointerdown", markInteracted, onceOptions);
    window.addEventListener("keydown", markInteracted, onceOptions);

    return () => {
      window.removeEventListener("scroll", markInteracted);
      window.removeEventListener("touchstart", markInteracted);
      window.removeEventListener("pointerdown", markInteracted);
      window.removeEventListener("keydown", markInteracted);
    };
  }, [deviceReady, hasInteracted]);

  const shouldLoadAnalytics = deviceReady && (!isMobile || hasInteracted);
  return (
    <>
      {shouldLoadAnalytics && (
        <>
          <Script
            async
            strategy="lazyOnload"
            src="https://www.googletagmanager.com/gtag/js?id=G-67KHB12RPL"
          />
          <Script id="google-analytics" strategy="lazyOnload">
            {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-67KHB12RPL');`}
          </Script>
        </>
      )}
    </>
  );
}
